export default function (val) {
  return `${val}`.replace(/^(\/de-smaa-ting\/forside)/ig, '')
}



// WEBPACK FOOTER //
// ./src/filters/parseurl.js